export const getImage = (prop: any) => {
    try {
        const src = require(`../assets/images/${prop}`)
        return src.default;
    }
    catch (err) {
        // console.log(err)
    }
}
